import "../../assets/HintText.css";
import { jsx as s } from "react/jsx-runtime";
const i = "_hint_10juf_3", o = {
  hint: i
}, h = ({
  children: t,
  ...n
}) => /* @__PURE__ */ s("span", { ...n, className: o.hint, children: t });
export {
  h as HintText
};
